import { render, staticRenderFns } from "./VStack.vue?vue&type=template&id=a6fe6d9e&scoped=true&"
import script from "./VStack.vue?vue&type=script&lang=js&"
export * from "./VStack.vue?vue&type=script&lang=js&"
import style0 from "./VStack.vue?vue&type=style&index=0&id=a6fe6d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fe6d9e",
  null
  
)

/* custom blocks */
import block0 from "./VStack.vue?vue&type=custom&index=0&blockType=meta"
if (typeof block0 === 'function') block0(component)
import block1 from "./VStack.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('VStack', component.exports)
}
export default component.exports